// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1jyk_","Menu":"Header_Menu__3jWav"};